import { GameVars } from './../../GameVars';
import { BattleScene } from './BattleScene';
import { AudioManager } from "./../../AudioManager";
import { GameManager } from "./../../GameManager";
import { GameConstants } from "../../GameConstants";

export class PauseMenu extends Phaser.GameObjects.Container {

    private restartButton: Phaser.GameObjects.Image;
    private homeButton: Phaser.GameObjects.Image;
    private continueButton: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const bck = new Phaser.GameObjects.Graphics(this.scene);
        bck.fillStyle(0x000000);
        bck.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);
        bck.alpha = .75;
        bck.setInteractive(new Phaser.Geom.Rectangle(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT), Phaser.Geom.Rectangle.Contains);
        bck.on("pointerup", () => { 
            BattleScene.currentInstance.hidePauseMenu();
        });
        this.add(bck);

        const topContainer = new Phaser.GameObjects.Container(this.scene);
        topContainer.x = GameConstants.GAME_WIDTH / 2;
        this.add(topContainer);

        this.continueButton = new Phaser.GameObjects.Image(this.scene, GameConstants.GAME_WIDTH / 2 - 45, 45, "texture_atlas_1", "btn_close_idle");
        this.continueButton.scaleX = this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
        this.continueButton.setInteractive();
        this.continueButton.on("pointerdown", () => { 
            this.continueButton.setFrame("btn_close_pressed");
        });
        this.continueButton.on("pointerup", () => {
            this.onClickContinue(); 
            this.continueButton.setFrame("btn_close_idle");
        });
        this.continueButton.on("pointerover", () => { 
            this.continueButton.setFrame("btn_close_over");
        });
        this.continueButton.on("pointerout", () => {
            this.continueButton.setFrame("btn_close_idle");
        });
        topContainer.add(this.continueButton);

        const midContainer = new Phaser.GameObjects.Container(this.scene);
        midContainer.x = GameConstants.GAME_WIDTH / 2;
        midContainer.y = GameConstants.GAME_HEIGHT / 2;
        this.add(midContainer);

        const titleBack = new Phaser.GameObjects.Image(this.scene, 0, -94, "texture_atlas_1", "campaign_" + (GameVars.currentMapZone + 1));
        titleBack.setOrigin(.5);
        titleBack.scaleX = .65;
        midContainer.add(titleBack);

        const title = new Phaser.GameObjects.Image(this.scene, 0, -102, "texture_atlas_1", "pause_text");
        title.setOrigin(.5);
        midContainer.add(title);

        const musicBtn = new Phaser.GameObjects.Image(this.scene, 50, 20, "texture_atlas_1", GameVars.gameData.soundtrackMuted ? "btn_music_idle_off" : "btn_music_idle");
        musicBtn.setInteractive();
        musicBtn.on("pointerdown", function () {
            musicBtn.setFrame(GameVars.gameData.soundtrackMuted ? "btn_music_pressed" : "btn_music_pressed_off");
            AudioManager.playSound("btn_click");
        }, this);
        musicBtn.on("pointerup", function () {
            AudioManager.toggleSoundtrackState();
            musicBtn.setFrame(GameVars.gameData.soundtrackMuted ? "btn_music_idle_off" : "btn_music_idle");
        }, this);
        musicBtn.on("pointerout", function () {
            musicBtn.setFrame(GameVars.gameData.soundtrackMuted ? "btn_music_idle_off" : "btn_music_idle");
        }, this);
        musicBtn.on("pointerover", function () {
            musicBtn.setFrame(GameVars.gameData.soundtrackMuted ? "btn_music_over" : "btn_music_over_off");
        }, this);
        midContainer.add(musicBtn);

        const fxBtn = new Phaser.GameObjects.Image(this.scene, -50, 20, "texture_atlas_1", GameVars.gameData.soundMuted ? "btn_fx_idle_off" : "btn_fx_idle");
        fxBtn.setInteractive();
        fxBtn.on("pointerdown", function () {
            fxBtn.setFrame(GameVars.gameData.soundMuted ? "btn_fx_pressed" : "btn_fx_pressed_off");
        }, this);
        fxBtn.on("pointerup", function () {
            AudioManager.toggleSoundState();
            AudioManager.playSound("btn_click");
            fxBtn.setFrame(GameVars.gameData.soundMuted ? "btn_fx_idle_off" : "btn_fx_idle");
        }, this);
        fxBtn.on("pointerout", function () {
            fxBtn.setFrame(GameVars.gameData.soundMuted ? "btn_fx_idle_off" : "btn_fx_idle");
        }, this);
        fxBtn.on("pointerover", function () {
            fxBtn.setFrame(GameVars.gameData.soundMuted ? "btn_fx_over" : "btn_fx_over_off");
        }, this);
        midContainer.add(fxBtn);

        this.restartButton = new Phaser.GameObjects.Image(this.scene, -50, 130, "texture_atlas_1", "btn_reset");
        this.restartButton.setInteractive();
        this.restartButton.on("pointerover", () => { this.onBtnOver(this.restartButton); });
        this.restartButton.on("pointerout", () => { this.onBtnOut(this.restartButton); });
        this.restartButton.on("pointerdown", () => { this.onBtnOut(this.restartButton); });
        this.restartButton.on("pointerup", () => { this.onClickRestart(); });
        midContainer.add(this.restartButton);

        this.homeButton = new Phaser.GameObjects.Image(this.scene, 50, 130, "texture_atlas_1", "btn_menu");
        this.homeButton.scaleX = this.scene.sys.game.device.os.desktop ? 1 : (1 / (GameVars.scaleX + GameVars.contrascaleX)) * GameVars.scaleX;
        this.homeButton.setInteractive();
        this.homeButton.on("pointerover", () => { this.onBtnOver(this.homeButton); });
        this.homeButton.on("pointerout", () => { this.onBtnOut(this.homeButton); });
        this.homeButton.on("pointerdown", () => { this.onBtnOut(this.homeButton); });
        this.homeButton.on("pointerup", () => { this.onClickHome(); });
        midContainer.add(this.homeButton);

        if (!this.scene.sys.game.device.os.desktop) {
            topContainer.scaleX = GameVars.scaleX + GameVars.contrascaleX;
            midContainer.scaleX = GameVars.scaleX;
        }

        this.visible = false;
    }

    private onBtnOver(btn: any): void {

        if (btn.alpha === 1) {
            btn.setScale(1.025);
        }
    }

    private onBtnOut(btn: any): void {
        
        if (btn.alpha === 1) {
            btn.setScale(1);
        }
    }

    private onClickRestart(): void {

        AudioManager.playSound("btn_click");

        GameManager.reset();
    }

    private onClickHome(): void {

        AudioManager.playSound("btn_click");

        if(GameConstants.LEVEL_EDITION) {
            GameManager.enterLevelsEditorScene();
        } else {
            GameManager.enterLobbyScene();
        }
    }

    private onClickContinue(): void {

        AudioManager.playSound("btn_click");

        BattleScene.currentInstance.hidePauseMenu();
    }
}
